// GUARDS ---------------------------------------------------------------- //

/** Safely parse a value that may be a JSON string or an already-parsed object */
export function parseJsonIfNeeded<T = unknown>(value: unknown): T | undefined {
  if (!value) return undefined;
  if (typeof value === 'object') return value as T;
  if (typeof value !== 'string') return undefined;

  try {
    return JSON.parse(value) as T;
  } catch {
    return undefined;
  }
}

/** Determine if a user role should see the Executive KPIs tab. Includes the
 *  internal admin role, matching the missing-ref report's admin-style check. */
export function isAdminStyleRole(role?: string | null): boolean {
  return role === 'admin' || role === 'dealer-admin' || role === 'dealer-super-admin';
}
